import { DsSynopticsXDataInterface } from '../interfaces/ds-synoptics-x-data.interface';
import { DsSynopticsGenericObject } from './ds-synoptics-generic-object';

/**
 * Data on the X axis, can represent a form instance on the synoptics.
 */
export class DsSynopticsXData extends DsSynopticsGenericObject {
  /**
   * Form instance state.
   */
  public state?: number;

  /**
   * Start X of the instance.
   */
  public startX?: number;

  /**
   * End X of the instance.
   */
  public endX?: number;

  /**
   * Work id to be able to filter on specific works.
   */
  public workId?: number;

  /**
   * Creates an instance of DsSynopticsXData.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsSynopticsXDataInterface) {
    super(jsonData);
    if (!jsonData) {
      return;
    }
    this.state = jsonData.state;
    this.startX = jsonData.startX;
    this.endX = jsonData.endX;
    this.workId = jsonData.workId;
  }
}
